// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"cf67ae2a","822":"ba2d8890","851":"5543f0e1"}[chunkId] + ".chunk.css";
};